import {
  SET_RENDER_LIST_PAGE,
  SET_RENDER_LIST_PAGE_TOTAL,
  SET_RENDER_LIST,
  SET_RENDER_LIST_QUERY,
  SET_RENDERING_LIST_QUERY,
  SET_RENDEREND_LIST_QUERY,
  SET_RENDERING_STATUS_LIST,
  SET_RENDEREND_STATUS_LIST,
  SET_RENDER_SORT,
  SET_RENDER_TASK_STATE_TYPE,
  SET_RENDER_LIST_PAGE_SIZE,
  SET_DETAIL_IMG_MESSAGE,
  SET_RENDER_TASK_COUNT,
  SET_RENDER_END_SEARCHING,
  SET_RENDER_RUNNING_SEARCHING,
  SET_RENDER_END_EXPORTING,
  SET_CONFIG_FILE,
  SET_MULTI_FRAME_CONFIG_FILE,
  IS_MULTI_FRAME,
  IS_HOUDINI_SINGLE,
  SET_JIGSAW_PREVIEW,
  RESET_RENDERING_LIST_QUERY,
  RESET_RENDEREND_LIST_QUERY,
  SET_FRAME_STATISTIC_MESSAGE,
  SET_TASK_SCENE_TYPE,
  SET_TASK_PARAM_OBJECT,
  SET_RENDER_TASK_LIST,
  SET_JSON_LIST_LOADING,
  SET_JSON_CUSTOM_MADE_LIST,
  SET_TASK_TYPE,
  SET_RENDER_PAGE_COUNT,
} from './mutation-types'
import files from 'file-saver'
import api from '@/api'
import _ from 'lodash'
import {getHeaderName, objectTrim} from '@/utils'
import { checkUserName } from '@/views/User/utils'
import { i18n } from '@/i18n'

const query = (taskFlag) => ({
  pageNum: 1,                    // int-每页显示的记录数
  pageSize: 50,                  // int-页码
  queryLastPageFlag: 0,          // int-是否查询最后一页，0：否，1：是
  userName: '',                  // String（条件查询 输入框 里面的参数）用户名
  userId: '',                    // String-条件查询 输入框 里面的参数）用户ID
  properties: '',                // string（条件查询 输入框 里面的参数）属性
  requirements: '',              // string（条件查询 输入框 里面的参数）要求
  constraints: '',               // string（条件查询 输入框 里面的参数）约束
  category: '',                  // string（条件查询 输入框 里面的参数）群组
  taskStatus: '',                // int（条件查询 下拉框 里面的参数）任务状态
  keywords: '',                  // String-平台id的字符串
  taskFlag: taskFlag,            // int-判断是运行还是渲染页面（0是运行，1是渲染）
  // areaId: '',                    // int（条件查询 下拉框 里面的参数）区域(SZ,SH)
  areaIds: '',                   // array（条件查询 下拉框 里面的参数）区域(SZ,SH)
  channel: '',                   // int（条件查询 下拉框 里面的参数）来源
  startTime: '',                 // timestamp-结束时间
  endTime: '',                   // timestamp-开始时间
  projectName: '',               // String-工程名
  sceneName: '',                 // String-场景名(文件名)
  failedFrameFlag: '',           // int（条件查询 筛选条件 里面的参数）失败帧
  isOverTimeFlag: '',            // int（条件查询 筛选条件 里面的参数）超时状态
  queryAdminId: '',              // int -（条件查询 下拉框 里面的参数）管理员
  isDelete: '',                  // 是否已删除，0：已删除，1：未删除
  taskIdFlag: '',                // int-根据任务ID号进行排序，值为1为升序，值为0为降序，否则为空
  executingFramesFlag: '',       // int-根据开始排序，值为1为升序，值为0为降序，否则为空
  doneFramesFlag: '',            // int-根据完成排序，值为1为升序，值为0为降序，否则为空
  abortFramesFlag: '',           // int-根据放弃帧排序，值为1为升序，值为0为降序，否则为空
  failFramesFlag: '',            // int-根据失败帧排序，值为1为升序，值为0为降序，否则为空
  // submitTimeFlag: '',            // int-根据提交时间排序，值为1为升序，值为0为降序，否则为空
  startTimeFlag: '',             // int-根据开始时间排序，值为1为升序，值为0为降序，否则为空
  endTimeFlag: '',               // int-根据结束时间排序，值为1为升序，值为0为降序，否则为空
  taskStartTimeFlag: '',             // int-根据开始时间排序，值为1为升序，值为0为降序，否则为空
  taskEndTimeFlag: '',               // int-根据结束时间排序，值为1为升序，值为0为降序，否则为空
  taskLevelFlag: '',             // int-根据作业等级排序，值为1为升序，值为0为降序，否则为空
  consumeFlag: '',               // int-根据扣费排序，值为1为升序，值为0为降序，否则为空
  reRenderCountFlag: '',         // int-根据重渲次数排序，值为1为升序，值为0为降序，否则为空
  // userIdFlag: '',             // int-根据用户ID排序，值为1为升序，值为0为降序，否则为空
  // abortFrameFlag: '',         // int（条件查询 筛选条件 里面的参数）放弃帧
  // taskStatusFlag: '',         // int-根据任务状态排序，值为1为升序，值为0为降序，否则为空
  // completedTimeFlag: '',      // int-根据结束时间排序，值为1为升序，值为0为降序，否则为空
  // taskGroup: '',              // String（条件查询 下拉框 里面的参数）区域(SZ,SH)
  adminTagName: '',              // 管理员标签
  cardFramesTask: 0,         // 卡帧作业 (1：查询；0或不传则不筛选卡帧作业)
  filterCompositeFrame: 0,    // 筛选合成作业 (1：查询；0或不传则不筛选卡帧作业)
  platform: '',
  stopType: '', // 1用户停止 2管理员停止 3欠费停止
  taskStatusList: [], // 状态勾选已停止（全部）和已完成（全部）需传
  cgId: '', // 软件配置
  pluginVersions: '', // 插件配置
  gpuNum: '', // GPU卡数
  taskTagFilters: '', // 任务标签
  aiAbnormalCode: '', // AI异常原因
})

const initImgMessage = () => ({
  imgUrlList: [],
  imgIndex: 0,
  imgUrl: '',
})

const state = {
  searching: false,
  endSearching: false,
  endExporting: false,
  initIngQuery: query('0'),
  initEdQuery: query('1'),
  renderRunning: {
    list: [],
    listPageTotal: 0,
    pageCount: 0,
    query: query('0'),
    sort: {
      submitTimeFlag: 0,
    },
    statusList: [],
  },
  renderCompleted: {
    list: [],
    listPageTotal: 0,
    pageCount: 0,
    query: query('1'),
    statusList: [],
    sort: {
      submitTimeFlag: 0,
    },
  },
  stateType: {},
  imgMessage: initImgMessage(),
  countTask: {
    waiting: 0,
    running: 0,
    aborted: 0,
    failure: 0,
    success: 0,
    total: 0,
  },
  configList: {},
  multiFrameConfigList: {},
  isMultiFrame: false,
  isHoudiniSingle: false, // 是否为houdini单机解算
  jigsawPreview: false,
  frameTips: {},
  sceneType: '',
  taskParamObj: {},
  renderTaskList: [],
  jsonLoading: false,
  taskJsonCustomMadeList: [],
  taskType: null,
}

const mutations = {
  [SET_RENDER_LIST] (state, payload) {
    state.stateType.list = payload
  },
  [SET_RENDER_LIST_PAGE] (state, payload) {
    state.stateType.query.pageNum = payload
  },
  [SET_RENDER_LIST_PAGE_TOTAL] (state, payload) {
    state.stateType.listPageTotal = payload
  },
  [SET_RENDER_PAGE_COUNT] (state, payload) {
    state.stateType.pageCount = payload
  },
  [SET_RENDER_LIST_QUERY] (state, payload) {
    state.stateType.query = payload
  },
  [SET_RENDERING_LIST_QUERY] (state, payload) {
    state.renderRunning.query = {
      ...state.renderRunning.query,
      ...payload,
    }
  },
  [SET_RENDEREND_LIST_QUERY] (state, payload) {
    state.renderCompleted.query = {
      ...state.renderCompleted.query,
      ...payload,
    }
  },
  [RESET_RENDERING_LIST_QUERY] (state, payload) {
    state.renderRunning.query = payload
  },
  [RESET_RENDEREND_LIST_QUERY] (state, payload) {
    state.renderCompleted.query = payload
  },
  [SET_RENDERING_STATUS_LIST] (state, payload) {
    state.renderRunning.statusList = payload
  },
  [SET_RENDEREND_STATUS_LIST] (state, payload) {
    state.renderCompleted.statusList = payload
  },
  [SET_RENDER_SORT] (state, payload) {
    state.stateType.sort = payload
  },
  [SET_RENDER_LIST_PAGE_SIZE] (state, payload) {
    state.stateType.query.pageSize = payload
  },
  [SET_RENDER_TASK_STATE_TYPE] (state, payload) {
    state.stateType = parseInt(payload) === 0 ? state.renderRunning : state.renderCompleted
  },
  [SET_DETAIL_IMG_MESSAGE] (state, payload) {
    state.imgMessage = {...state.imgMessage, ...payload}
  },
  [SET_RENDER_TASK_COUNT] (state, payload) {
    state.countTask = payload !== null ? payload : state.countTask
  },
  [SET_RENDER_RUNNING_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_RENDER_END_SEARCHING] (state, payload) {
    state.endSearching = payload
  },
  [SET_RENDER_END_EXPORTING] (state, payload) {
    state.endExporting = payload
  },
  [SET_CONFIG_FILE] (state, payload) {
    state.configList = payload
  },
  [SET_MULTI_FRAME_CONFIG_FILE] (state, payload) {
    state.multiFrameConfigList = payload
  },
  [IS_MULTI_FRAME] (state, payload) {
    state.isMultiFrame = payload
  },
  [IS_HOUDINI_SINGLE] (state, payload) {
    state.isHoudiniSingle = payload
  },
  [SET_JIGSAW_PREVIEW] (state, payload) {
    state.jigsawPreview = payload
  },
  [SET_FRAME_STATISTIC_MESSAGE] (state, payload) {
    state.frameTips = payload
  },
  [SET_TASK_SCENE_TYPE] (state, payload) {
    state.sceneType = payload
  },
  [SET_TASK_PARAM_OBJECT] (state, payload) {
    state.taskParamObj = payload
  },
  [SET_RENDER_TASK_LIST] (state, payload) {
    state.renderTaskList = payload
  },
  [SET_JSON_LIST_LOADING](state, payload) {
    state.jsonLoading = payload
  },
  [SET_JSON_CUSTOM_MADE_LIST](state, payload) {
    state.taskJsonCustomMadeList = payload
  },
  [SET_TASK_TYPE] (state, payload) {
    state.taskType = payload
  },
}

const actions = {
  // 运行的渲染作业列表
  async getRenderList ({commit, state, dispatch}, statusFlag) {
    try {
      if (statusFlag !== undefined) commit(SET_RENDER_TASK_STATE_TYPE, statusFlag)
      let query = {}
      _.forIn(state.stateType.query, (v, k) => {
        v = v === true ? 1 : v === false ? '' : v
        if (k === 'keywords' || (v instanceof Array && v.length > 0) || (v instanceof Array === false && v !== '')) {
          query[k] = v
        }
      })
      console.log(state.stateType.query, 'query')
      console.log(state.stateType.sort, 'state.stateType.sort')
      if (query['taskStatus']) delete query['taskFlag']
      if (typeof query['areaIds'] === 'string') query['areaIds'] = [parseInt(query['areaIds'])]
      const computedFlag = String(query.taskStatus).includes('70-')
      if (computedFlag && typeof query.taskStatus === 'string') {
        let tempArr = query.taskStatus.split('-')
        query.stopType = Number(tempArr[1])
        query.taskStatus = Number(tempArr[0])
      }
      let params = {
        ...query,
        ...state.stateType.sort,
      }
      const getData = async (param) => {
        if (statusFlag === '1') commit(SET_RENDER_END_SEARCHING, true)
        else commit(SET_RENDER_RUNNING_SEARCHING, true)
        const { data, code } = await api.taskApi.getRenderList(param)
        // eslint-disable-next-line no-undef
        const _this = vm
        const query = _this.$route.query
        checkUserName({
          code,
          data,
          callback: ({userId}) => {
            param.userId = userId
            delete param.userName
            query.userId = userId
            delete query.userName
            _this.$router.push({query: objectTrim(query)})
            getData(param)
          },
          onCancel: () => {
            delete query.userName
            _this.$router.push({query: objectTrim(query)})
          },
        })
        commit(SET_RENDER_RUNNING_SEARCHING, false)
        commit(SET_RENDER_END_SEARCHING, false)
        if (code !== 200) return
        let items = data.items
        let pageNum = data.pageNum
        let total = data.total
        let pageCount = data.pageCount
        items.map((itm, idx) => {
          itm.taskFlag = query.taskFlag
          // if (idx % 3 === 0) itm.photon = 1 // 1, 为光子停止， 2，为光子失败
          // else itm.photon = 2
        })
        // 初始化父任务的展开状态以及对子任务的标记
        commit(SET_RENDER_LIST_PAGE, pageNum)
        commit(SET_RENDER_LIST_PAGE_TOTAL, total)
        commit(SET_RENDER_LIST, items)
        commit(SET_RENDER_PAGE_COUNT, pageCount)
      }
      await getData(params)
      if (statusFlag === 0) {
        await dispatch('queryTaskOfPlatformStat')
      }
    } catch (error) {
      commit(SET_RENDER_RUNNING_SEARCHING, false)
      commit(SET_RENDER_END_SEARCHING, false)
      commit(SET_RENDER_LIST_PAGE_TOTAL, 0)
      commit(SET_RENDER_LIST, [])
    }
  },
  // 初始化列表
  async initRenderList ({commit, state, dispatch}, statusFlag) {
    // let query = {  // 取消重置 query, 日期8-19-gt, 需求, 不清楚会产生什么影响
    //   userId: '',
    //   keywords: '',
    //   taskFlag: statusFlag,
    // }
    commit(SET_RENDER_TASK_STATE_TYPE, statusFlag)
    // commit(SET_RENDER_LIST_QUERY, query) // 取消重置 query, 日期8-19-gt, 需求, 不清楚会产生什么影响
    commit(SET_RENDER_SORT, {submitTimeFlag: 0})
    commit(SET_RENDER_LIST_PAGE, 1)
    commit(SET_RENDER_LIST_PAGE_SIZE, 50)
    await dispatch('getRenderList', statusFlag)
  },
  // 运行的渲染作业列表翻页
  changeRenderListPage ({commit, state, dispatch}, {currentPage}) {
    commit(SET_RENDER_LIST_PAGE, currentPage)
  },
  // 运行的渲染作业排序
  changeRenderSort ({commit, dispatch}, payload) {
    commit(SET_RENDER_SORT, payload)
    dispatch('changeRenderListPage', {currentPage: 1})
    dispatch('getRenderList')
  },
  // 筛选渲染作业
  async changeRenderingQuery ({commit, dispatch}, payload) {
    commit(SET_RENDERING_LIST_QUERY, payload)
    await dispatch('getRenderList', 0)
  },
  async changeRenderendQuery ({commit, dispatch}, payload) {
    commit(SET_RENDEREND_LIST_QUERY, payload)
    await dispatch('getRenderList', 1)
  },
  // 设置筛序渲染作业的筛选条件
  setRenderingQuery ({commit}, payload) {
    commit(SET_RENDERING_LIST_QUERY, payload)
  },
  setRenderendQuery ({commit}, payload) {
    commit(SET_RENDEREND_LIST_QUERY, payload)
  },
  // 重置筛选参数
  resetRenderingQuery ({commit, state}) {
    commit(RESET_RENDERING_LIST_QUERY, state.initIngQuery)
  },
  resetRenderendQuery ({commit, state}) {
    commit(RESET_RENDEREND_LIST_QUERY, state.initEdQuery)
  },
  // 重置排序
  resetRenderSort ({dispatch}) {
    dispatch('changeRenderSort', {})
  },
  // 改变每页显示条数
  changePageSize ({commit, dispatch}, payload) {
    commit(SET_RENDER_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeRenderListPage', {currentPage: 1})
  },
  // 停止状态
  // eslint-disable-next-line
  async rendingStopTask ({}, payload) {
    const data = await api.taskApi.stopTask(payload)
    return data
  },
  // 开始状态
  // eslint-disable-next-line
  async rendingStartTask ({}, payload) {
    const data = await api.taskApi.startTask(payload)
    return data
  },
  // 全速渲染
  // eslint-disable-next-line
  async rendingFullSpeed ({}, payload) {
    const data = await api.taskApi.fullSpeedRender(payload)
    return data
  },
  // 全速渲染优先帧
  // eslint-disable-next-line
  async rendingPriorityFullSpeed ({}, payload) {
    const data = await api.taskApi.handleMaxPriority(payload)
    return data
  },
  // 修改级别按钮
  // eslint-disable-next-line
  async updateLevel ({}, payload) {
    const data = await api.taskApi.updateLevel(payload)
    return data
  },
  // 修改节点数量按钮
  // eslint-disable-next-line
  async updateNodeLimit ({}, payload) {
    const data = await api.taskApi.updateNodeLimit(payload)
    return data
  },
  // 修改备注按钮
  // eslint-disable-next-line
  async updateRemark ({}, payload) {
    const data = await api.taskApi.updateRemark(payload)
    return data
  },
  // 帧详情任务
  // eslint-disable-next-line
  async updateNodeCountAndLevel ({}, payload) {
    const data = await api.taskApi.updateNodeCountAndLevel(payload)
    return data
  },
  // 设置超时时间
  // eslint-disable-next-line
  async setTaskOverTime ({}, payload) {
    const data = await api.taskApi.setTaskOverTime(payload)
    return data
  },
  // 帧任务详情
  // 帧详情任务列表
  // eslint-disable-next-line
  async getTaskFrameRenderList ({commit}, payload) {
    const {data} = await api.taskApi.getTaskFrameRenderList(payload)
    return data
  },
  // 扣费记录
  async getTaskFrameConsumeInfo ({commit}, payload) {
    const data = await api.taskApi.getTaskFrameConsumeInfo(payload)
    return data
  },
  // 查询帧耗时分布图以及帧完成情况
  // eslint-disable-next-line
  async getFrameCondition ({}, payload) {
    const {data} = await api.taskApi.getFrameCondition(payload)
    return data
  },
  // 查询配置详情
  // eslint-disable-next-line
  async loadingTaskParameter({commit}, payload) {
    const {data} = await api.taskApi.loadingTaskParameter(payload)
    const { sceneName, taskParam, taskType } = data
    console.log(taskType, 'taskType')
    commit(SET_TASK_TYPE, taskType)
    const sceneType = sceneName && sceneName.match(/(?!=\.)[^.]+$/g)
    commit(SET_TASK_SCENE_TYPE, sceneType ? sceneType[0] : '')
    const paramObj = (taskParam || []).reduce((res, cur) => {
      const [key, val] = cur.split('|')
      const numberKeys = ['render_blocker_num', 'analysis_multi_selection_multi_label']
      res[key] = numberKeys.includes(key) ? +val : val
      return res
    }, {})
    console.dir(paramObj)
    commit(SET_TASK_PARAM_OBJECT, paramObj)
    return {
      ...data,
      taskParam: taskParam || [],
    }
  },
  // 查询配置文档
  // eslint-disable-next-line
  async getTaskJson ({}, payload) {
    const {data} = await api.taskApi.getTaskJson(payload)
    return data
  },
  // 加载帧的缩略图
  // eslint-disable-next-line
  async loadingTaskThumbnail({}, payload) {
    const data = await api.taskApi.loadingTaskThumbnail(payload)
    return data
  },
  // 加载帧的截图
  // eslint-disable-next-line
  async loadingTaskGrab({}, payload) {
    const data = await api.taskApi.loadingTaskGrab(payload)
    return data
  },
  // 查看日志
  // eslint-disable-next-line
  async setRenderLogDetails ({}, {renderingType, render, munu, pageNum, flag, nodeIp, nodePort, nodeName}) {
    // if (renderingType === 'munuLog') {
    //   // if (!munu.munuTaskId) return []
    //   const {data} = await api.taskApi.getMunuLog({
    //     ...munu,
    //     pageNum,
    //   })
    //   return data
    // } else {
    const {data} = await api.taskApi.getRenderLog({
      ...render,
      renderingType,
      pageNum,
      flag,
      nodeIp,
      nodePort,
      nodeName,
    })
    return data
    // }
  },
  // 查看错误信息、关键信息、未知节点
  async setRenderErrorLogDetails ({commit}, {renderingType, render, pageNum, type}) {
    const {data} = await api.taskApi.getRenderErrorLog({
      ...render,
      renderingType,
      type,
    })
    return data
  },

  // 重提帧任务
  // eslint-disable-next-line
  async recommitTaskFrame ({}, payload) {
    const data = await api.taskApi.recommitTaskFrame(payload)
    return data
  },
  // 停止帧任务
  // eslint-disable-next-line
  async stopTaskFrame ({}, payload) {
    const data = await api.taskApi.stopTaskFrame(payload)
    return data
  },
  // 开始帧任务
  // eslint-disable-next-line
  async startTaskFrame ({}, payload) {
    const data = await api.taskApi.startTaskFrame(payload)
    return data
  },
  // 删除任务
  // eslint-disable-next-line
  async deleteTask ({}, payload) {
    const data = await api.taskApi.deleteTask(payload)
    return data
  },
  // 导出作业Excel
  async exportTaskExcel ({commit, state, dispatch}, payload) {
    commit(SET_RENDER_END_EXPORTING, true)
    const query = {}
    for (let key in state.stateType.query) {
      if (state.stateType.query[key] || state.stateType.query[key] === 0) query[key] = state.stateType.query[key]
    }
    const params = {
      ...query,
      ...payload,
    }
    if (payload && !payload.userName && params.userName) {
      delete params.userName
    }
    const res = await api.taskApi.exportTaskExcel(params)
    const {data, headers} = res
    try {
      const fileName = getHeaderName(headers).replace(/\"/g, '')
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (error) {
      const reader = new FileReader()
      reader.onload = () => {
        const result = JSON.parse(reader.result)
        const { code, data } = result
        checkUserName({
          code,
          data,
          callback: ({userId}) => {
            const { userName, ...other } = params
            dispatch('exportTaskExcel', {
              ...other,
              userId,
            })
          },
        })
      }
      reader.readAsText(res.data)
    }
    commit(SET_RENDER_END_EXPORTING, false)
  },
  setDetailImgMessage ({commit}, payload) {
    commit(SET_DETAIL_IMG_MESSAGE, payload)
  },
  resetImgMessage ({commit}) {
    commit(SET_DETAIL_IMG_MESSAGE, initImgMessage())
  },
  clearDetailImgMessage ({commit}) {
    commit(SET_DETAIL_IMG_MESSAGE, {})
  },
  // 运行的渲染作业统计
  async queryTaskOfPlatformStat ({commit}) {
    const data = await api.taskApi.queryTaskOfPlatformStat()
    if (data.result) {
      commit(SET_RENDER_TASK_COUNT, data.data)
    }
  },
  // 获取任务帧总数及费用
  async getSumFrameConsume ({commit}, payload) {
    const {data} = await api.taskApi.getSumFrameConsume(payload)
    return data
  },
  // 恢复任务
  async regainTask ({commit}, payload) {
    const data = await api.taskApi.regainTask(payload)
    return data
  },
  // 清空黑名单
  async cleanRenderBlackList ({commit}, payload) {
    const data = await api.taskApi.cleanRenderBlackList(payload)
    return data
  },
  // 查询配置文档名称
  async getJsonFileName ({commit}, payload) {
    const { data } = await api.taskApi.getJsonFileName(payload)
    var frameFile = Object.entries(data).filter(k => !/.*(json|txt|cfg|org)$/g.test(k))
    if (frameFile.length > 0) {
      try {
        var jsonFile = Object.entries(data).filter(k => /.*(json|txt|cfg|org)$/g.test(k))
        var jsonFileDict = {}
        var frameFileDict = {}
        jsonFile.forEach(j => {
          jsonFileDict[j[0]] = j[1]
        })
        frameFile.forEach(f => {
        // var key = f[0].match(/(?!.*_).*/g)[0]
          var result = f[0].match(/_([^_]*)/g)
          if (result) {
            var keyMunuId = result[0].replace('_', '')
            var keyFrame = result[2].replace('_', '')
            var key = `${keyMunuId}#${keyFrame}`
            frameFileDict[key] = f[1]
          }
        })
        commit(SET_CONFIG_FILE, jsonFileDict)
        commit(SET_MULTI_FRAME_CONFIG_FILE, frameFileDict)
      } catch (error) {
        commit(SET_CONFIG_FILE, jsonFileDict)
        console.error(error)
      }
    } else {
      commit(SET_CONFIG_FILE, data)
      commit(SET_MULTI_FRAME_CONFIG_FILE, {})
    }
    return data
  },
  // 查看历史重渲记录
  async getHistoryRenderInfo ({commit}, payload) {
    const {data} = await api.taskApi.getHistoryRenderInfo(payload)
    if (data === 'MUNU_NO_RESOURCES') return []
    else return data
  },
  // 查看预处理作业历史重渲记录
  async getPreHistoryRenderInfo ({commit}, payload) {
    const {data} = await api.taskApi.getPreHistoryRenderInfo(payload)
    if (data === 'MUNU_NO_RESOURCES') return []
    else return data
  },
  // 判断任务是否一机多帧
  isMultiFrameInOneMechine ({commit}, payload) {
    commit(IS_MULTI_FRAME, payload)
  },
  // 判断任务是否为houdini单机解算
  setHoudiniSingle ({commit}, payload) {
    commit(IS_HOUDINI_SINGLE, payload)
  },
  // 判断是否提供拼接预览功能
  isProvidedJigsawPreview ({commit}, payload) {
    commit(SET_JIGSAW_PREVIEW, payload)
  },
  // 加载分块任务的所有分块图片
  async getJigsawImgs ({state}, payload) {
    const {data} = await api.taskApi.getJigsawPreview(payload)
    return data
  },
  // 获取帧详情列表的帧统计信息
  async getFrameStatisticMessage ({commit}, payload) {
    const {data} = await api.taskApi.getFrameStatisticMessage(payload)
    commit(SET_FRAME_STATISTIC_MESSAGE, data)
  },
  // 任务帧状态与卡帧计数（整任务维度）
  async getTaskFrameStatusCount ({commit}, payload) {
    const {data} = await api.taskApi.getTaskFrameStatusCount(payload)
    return data
  },
  // 获取用户输入输出路径
  async getOutOrInputPath ({commit}, payload) {
    const data = await api.taskApi.getOutOrInputPath(payload)
    return data
  },
  // 单个用户所有金额统计
  async queryAmount ({commit}, payload) {
    const {data, result} = await api.taskApi.queryAmount(payload)
    return {data, result}
  },
  // 查询账户信息
  async queryAccountInfo ({commit}, payload) {
    const {data, result} = await api.taskApi.queryAccountInfo(payload)
    return {data, result}
  },
  // 更新修改标签
  async updateTaskLabel ({commit}, payload) {
    const {data, result, code, message} = await api.taskApi.updateTaskLabel(payload)
    return {data, result, code, message}
  },
  // 更新内存
  async upgradeTaskRam ({commit}, payload) {
    const {data, result, code, message} = await api.taskApi.upgradeTaskRam(payload)
    return {data, result, code, message}
  },
  // 内存信息
  async advanceParameterSetting ({commit}, payload) {
    const {data, result, code, message} = await api.taskApi.advanceParameterSetting(payload)
    return {data, result, code, message}
  },
  // 选择的rendertask
  async setRenderTaskList ({commit}, payload) {
    commit(SET_RENDER_TASK_LIST, payload)
  },
  // 新增管理员标签
  async addAdminLabel ({commit}, payload) {
    const {code, message} = await api.taskApi.addAdminLabel(payload)
    return {code, message}
  },
  // 删除管理员标签
  async deleteAdminLabel ({commit}, payload) {
    const {code, message} = await api.taskApi.deleteAdminLabel(payload)
    return {code, message}
  },
  // 获取管理员标签
  async getAdminLabel ({commit}, payload) {
    const {data, code, message} = await api.taskApi.getAdminLabel(payload)
    return {data, code, message}
  },
  async queryTag (ctx, payload) {
    const { data } = await api.taskApi.queryTag(payload)
    return data || []
  },
  async deleteAdminTag (ctx, payload) {
    return api.taskApi.deleteAdminTag(payload)
  },
  // 给任务添加标签
  async addTaskAdminLabel ({commit}, payload) {
    const {code, message} = await api.taskApi.addTaskAdminLabel(payload)
    return {code, message}
  },
  // 给任务添加标签
  async deleteTaskAdminLabel ({commit}, payload) {
    const {code, message} = await api.taskApi.deleteTaskAdminLabel(payload)
    return {code, message}
  },
  // 获取任务关联工单
  async getJiraIssues ({commit}, payload) {
    const {code, data} = await api.taskApi.getJiraIssues(payload)
    return {code, data}
  },
  // 获取提交失败的错误信息
  async getSubmitTaskFailMessage ({commit}, taskId) {
    const {code, data} = await api.taskApi.getSubmitTaskFailMessage({taskId})
    return {code, data}
  },
  // json文件定制列表
  async getTaskJsonCustomMadeList({ commit, state }, payload) {
    try {
      commit(SET_JSON_LIST_LOADING, true)
      let { data } = await api.taskApi.queryTaskJsonFileCustomizationList(payload)
      commit(SET_JSON_LIST_LOADING, false)
      commit(SET_JSON_CUSTOM_MADE_LIST, data)
    } catch (error) {
      commit(SET_JSON_CUSTOM_MADE_LIST, [])
    }
  },
  // 据id删除任务json文件定制
  async deleteTaskJsonFileCustomizationById({ dispatch }, payload) {
    const data = await api.taskApi.deleteTaskJsonFileCustomizationById(payload)
    return data
  },
  // 获取任务费用统计
  async getRenderingTaskConsume({commit, state}, payload) {
    let query = {}
    _.forIn(state.stateType.query, (v, k) => {
      v = v === true ? 1 : v === false ? '' : v
      if (k === 'keywords' || (v instanceof Array && v.length > 0) || (v instanceof Array === false && v !== '')) {
        query[k] = v
      }
    })
    if (query['taskStatus']) delete query['taskFlag']
    if (typeof query['areaIds'] === 'string') query['areaIds'] = [parseInt(query['areaIds'])]
    const computedFlag = String(query.taskStatus).includes('70-')
    if (computedFlag && typeof query.taskStatus === 'string') {
      let tempArr = query.taskStatus.split('-')
      query.stopType = Number(tempArr[1])
      query.taskStatus = Number(tempArr[0])
    }
    let params = {
      ...query,
      ...state.stateType.sort,
    }
    const data = await api.taskApi.getRenderingTaskConsume(params)
    return data
  },
  // 获取总任务数
  async getRenderingTaskTotal({commit, state}, payload) {
    let query = {}
    _.forIn(state.stateType.query, (v, k) => {
      v = v === true ? 1 : v === false ? '' : v
      if (k === 'keywords' || (v instanceof Array && v.length > 0) || (v instanceof Array === false && v !== '')) {
        query[k] = v
      }
    })
    if (query['taskStatus']) delete query['taskFlag']
    if (typeof query['areaIds'] === 'string') query['areaIds'] = [parseInt(query['areaIds'])]
    const computedFlag = String(query.taskStatus).includes('70-')
    if (computedFlag && typeof query.taskStatus === 'string') {
      let tempArr = query.taskStatus.split('-')
      query.stopType = Number(tempArr[1])
      query.taskStatus = Number(tempArr[0])
    }
    let params = {
      ...query,
      ...state.stateType.sort,
    }
    const data = await api.taskApi.getRenderingTaskTotal(params)
    return data
  },
}

const getters = {
  imgUrl(state) {
    if (state.imgMessage.imgUrlList && state.imgMessage.imgUrlList.length > 0) {
      return `${state.imgMessage.imgUrlList[state.imgMessage.imgIndex].replace(/#/g, '%23')}.jpg?t=${+new Date()}`
    }
    return ''
  },
  imgName(state) {
    if (state.imgMessage.imgUrlList && state.imgMessage.imgUrlList.length > 0) {
      const arr = state.imgMessage.imgUrlList[state.imgMessage.imgIndex].split('/')
      return arr[arr.length - 1]
    }
    return i18n.t('task_noImage')
  },
  // 是否一机多帧
  isMultiFrame(state) {
    return state.taskParamObj.analysis_multi_selection_multi_label > 1
  },
  // 是否分块
  isBlock(state) {
    return state.taskParamObj.render_blocker_num >= 1
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
